import {RedemptionReportDuration} from "@irati/types"

export const ALL_TEAMS = "ALL"
export const LAST_30_DAYS = RedemptionReportDuration.Last_30Days
export const LAST_12_MONTHS = RedemptionReportDuration.Last_12Months
export const MONTHLY = RedemptionReportDuration.Monthly
export const QUARTERLY = RedemptionReportDuration.Quarterly
export const LIMIT = 15

export interface Option {
  value: string
  label: string
}

export interface Filters {
  businessUnitIds?: string[]
  teamId?: string
  month?: string
  currency?: string
}
